'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_io$002eintela$002esites$002edigitalinternship$002eui$002e$002dButton from "./io.intela.sites.digitalinternship.ui.-Button.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_ui_Button$$anon$2() {
  this.fF = null;
  $j_io$002eintela$002esites$002edigitalinternship$002eui$002e$002dButton.$ct_Lio_intela_sites_digitalinternship_ui_Button__T__(this, "btn btn-outline btn-primary btn-lg");
}
export { $c_Lio_intela_sites_digitalinternship_ui_Button$$anon$2 as $c_Lio_intela_sites_digitalinternship_ui_Button$$anon$2 };
$p = $c_Lio_intela_sites_digitalinternship_ui_Button$$anon$2.prototype = new $j_io$002eintela$002esites$002edigitalinternship$002eui$002e$002dButton.$h_Lio_intela_sites_digitalinternship_ui_Button();
$p.constructor = $c_Lio_intela_sites_digitalinternship_ui_Button$$anon$2;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_ui_Button$$anon$2() {
}
export { $h_Lio_intela_sites_digitalinternship_ui_Button$$anon$2 as $h_Lio_intela_sites_digitalinternship_ui_Button$$anon$2 };
$h_Lio_intela_sites_digitalinternship_ui_Button$$anon$2.prototype = $p;
$p.G = (function() {
  return 0;
});
$p.H = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.I = (function() {
  return "Outline";
});
$p.t = (function() {
  return "Outline";
});
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("Outline");
});
var $d_Lio_intela_sites_digitalinternship_ui_Button$$anon$2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_ui_Button$$anon$2, "io.intela.sites.digitalinternship.ui.Button$$anon$2", ({
  fA: 1,
  bU: 1,
  b: 1,
  e: 1,
  a: 1,
  C: 1,
  V: 1,
  y: 1,
  N: 1,
  S: 1
}));
export { $d_Lio_intela_sites_digitalinternship_ui_Button$$anon$2 as $d_Lio_intela_sites_digitalinternship_ui_Button$$anon$2 };
//# sourceMappingURL=io.intela.sites.digitalinternship.ui.-Button$$anon$2.js.map
